import Cookie from 'js-cookie';

const DEFAULT_DOMAIN = 'onetwotrip.com';
const referrersWhiteList = ['yandex_direct', 'google_adwords'];

const needOpenHotelPopunder = () => {
  const referrer = Cookie.get('referrer');

  return referrersWhiteList.includes(referrer);
};

const saveHotelsPopunderOpened = () => {
  Cookie.set('hotelsPopunderOpened', 'true', { domain: DEFAULT_DOMAIN, expires: 1 });
};

const isHotelsPopunderOpened = () => {
  return Cookie.get('hotelsPopunderOpened');
};

export { DEFAULT_DOMAIN, needOpenHotelPopunder, saveHotelsPopunderOpened, isHotelsPopunderOpened };
